module.exports = __webpack_public_path__ + "img/ab2.svg";